// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Ctmp","title":"AfterBackImages_title__aVDYk","images":"AfterBackImages_images__YnOWm"};